import { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../lib/firebase';

const useLogout = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const logout = async () => {
    setLoading(true);
    setError(null);
    try {
      await signOut(auth);
      // After sign out, no need to manually clear user state here,
      // because your useAuth hook listens to onAuthStateChanged and will update automatically.
    } catch (err) {
      setError(err.message || 'Failed to logout');
    } finally {
      setLoading(false);
    }
  };

  return { logout, error, loading };
};

export default useLogout;
